export const loadScript = function ({ url, async = false, rejectTimeout = 0 }: {
  url: string
  async?: boolean
  rejectTimeout?: number
}): Promise<void> {
  return new Promise(function (resolve, reject) {
    const script = document.createElement('script')
    script.src = url
    script.async = async

    if (rejectTimeout) {
      setTimeout(() => reject(new Error(`Истек таймаут загрузки скрипта ${url}`)), rejectTimeout)
    }

    script.addEventListener('load', function () {
      resolve()
    })

    document.head.appendChild(script)
  })
}

export const LoadCSS = (cssURL): Promise<void> => {
  return new Promise(function (resolve) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = cssURL
    document.head.appendChild(link)
    link.onload = function () {
      resolve()
    }
  })
}
